import get from "lodash/get";
import isNil from "lodash/isNil";

import type { CreatingSteps } from "app/pages/activation/components/RankWidget/types";
import { ActivationComponentAssets } from "app/pages/activation/helpers/ActivationAssets";
import { useToggle } from "app/pages/activation/hooks/useToggle";
import { useGetRTCountriesQuery } from "app/pages/activation/queries/rankTracker/useGetRTCountriesQuery";
import { activationTracking } from "app/pages/activation/services/tracking";
import type { ShortActivationSetSchema } from "app/pages/activation/types/api";

import { useTopicsDataContext } from "../../context/Topics/TopicsDataContext";

export const useRTCreationModal = (project: ShortActivationSetSchema) => {
    const { data: topics } = useTopicsDataContext();

    const [isCreationOpen, onOpenCreation, onCloseCreation] = useToggle();
    const isRtApiEnabled = ActivationComponentAssets.isRankTrackerActivationApiEnabled;
    const RTCampaignId = get(project, "assets.rankTrackerCampaignId");

    const { data: availableCountries, isLoading: isCountriesLoading } = useGetRTCountriesQuery(
        !RTCampaignId && isRtApiEnabled,
    );

    const { rankTracker } = activationTracking;

    const onCreateCampaignClick = () => {
        rankTracker.trackClickCreateCampaignButton(topics?.length);
        onOpenCreation();
    };

    const onCreationClose = (step?: CreatingSteps) => {
        if (!isNil(step)) {
            rankTracker.trackCancelCreation(step);
        }

        onCloseCreation();
    };

    return {
        isCreationOpen,
        onOpenCreation: onCreateCampaignClick,
        onCloseCreation: onCreationClose,
        domain: get(project, "primaryDomain", ""),
        competitors: get(project, "competitorsDomains", []),
        country: get(project, "country", 0),
        projectName: get(project, "name", ""),
        projectId: get(project, "id", ""),
        availableCountries,
        isCountriesLoading,
    };
};
